import React, { useState } from 'react';
import T from 'i18n-react';
import { useRouter } from 'next/router';

import { Modal } from '@motorway/motorway-storybook-cra';

import useAccountRouter from 'Components/Account/useAccountRouter';
import texts from 'Components/texts.json';
import { triggerAccountPageSearchInputEvent } from 'Services/analytics/events';
import { setAccountFilter } from 'Stores/AccountFiltersStore/AccountFiltersStore.helpers';
import { AccountDateRange, SortBy } from 'Types/account';
import { Order } from 'Types/generic';
import { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';
import { isString } from 'Utilities/helpers';
import useKeywordSearch from 'Utilities/hooks/useKeywordSearch';

import AccountPurchaseCompleteMobileModal from './AccountPurchaseCompleteMobileModal/AccountPurchaseCompleteMobileModal';
import AccountInputWithButton from './AccountInputWithButton';

import styles from './AccountPurchaseCompleteMobileModal/AccountPurchaseCompleteMobileModal.module.scss';

T.setTexts(texts);

type AccountPurchaseCompleteMobileProps = {
	count?: number;
};
const AccountPurchaseCompleteMobile: React.FC<AccountPurchaseCompleteMobileProps> = ({ count }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const router = useRouter();
	const { changePage, keyword, slug } = useAccountRouter();

	const toggleModal = () => setIsModalOpen(!isModalOpen);

	const { onClear, onSearch } = useKeywordSearch({
		initialKeyword: keyword,
		searchFunction: ({ keyword: searchKeyword }) => {
			const trimmedSearchKeyword = isString(searchKeyword) ? searchKeyword?.trim() : searchKeyword;
			changePage({ keyword: trimmedSearchKeyword });
			triggerAccountPageSearchInputEvent({ searchTerm: trimmedSearchKeyword, slug });
		},
	});

	const onClearFilters = () => {
		onClear();
		toggleModal();
		setAccountFilter(router, {
			dateRangeType: AccountDateRange.ALL,
			hideDelivered: false,
			keyword: undefined,
			order: Order.Descending,
			purchasesCompleteStatusType: PurchasesCompleteStatusTypes.All,
			sortBy: SortBy.DATE_WON,
		});
	};

	return (
		<>
			<AccountInputWithButton
				inputConfig={{
					inputProps: {
						id: 'purchase-complete-mobile-search',
						initialValue: '',
						input: {
							name: 'purchase-complete-mobile-search',
							placeholder: String(
								T.translate('account.search.placeholder', {
									section: T.translate(`account.sidebar.sectionLinks.${slug}`),
								}),
							),
						},
					},
				}}
				onButtonClick={toggleModal}
				onClearInput={onClear}
				onInputChange={onSearch}
			/>
			{isModalOpen && (
				<Modal noPadding contentClass={styles.modal} dismissModal={toggleModal} size="small">
					<AccountPurchaseCompleteMobileModal
						count={count}
						onClearAllFilters={onClearFilters}
						onShowVehicles={toggleModal}
					/>
				</Modal>
			)}
		</>
	);
};

export default AccountPurchaseCompleteMobile;
